import PropTypes from 'prop-types'
import './styles.scss'

export function Slider ({ label, value, ...rest }) {
  return (
    <div className='nh-slider'>
      <label>{label}</label>
      <span />
      <input
        type='range'
        min={0}
        max={10}
        value={value || 0}
        {...rest}
      />
    </div>
  )
}
Slider.propTypes = {
  label: PropTypes.string
}
